import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './assets/font/iconfont.css'    // 引入阿里云字体图标css
import './assets/sass/index.scss' // 全局样式

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn';

import i18n from './i18n'

createApp(App).use(ElementPlus,{ locale: zhCn }).use(store).use(router).use(i18n).mount('#app')
